import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { borderRadius, flex, position, space, textAlign, width } from "styled-system";
import { color, elevation } from "./css";

var Panel = /*#__PURE__*/_styled("div", {
  shouldForwardProp: shouldForwardProp,
  target: "ec0sw5y0"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("label:base;margin:0;padding:", theme.space.md, ";box-shadow:", theme.elevations[2], ";background:white;border-radius:", theme.radii.md, ";");
}, color, borderRadius, elevation, flex, position, space, textAlign, width);

Panel.displayName = "Panel";
export default Panel;